/*
 * ReactQuery.js
 *
 * Speakers
 * Created by Mahdi Yousefpour on Fri Feb 03 2023 mys Company
 */

import { QueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import { localization } from '../localize/localizable'

const QueryErrorHandler = async (error) => {
    // const navig = useMyNavigate()

    switch (error.response.status) {
        case 401:
            localStorage.clear()
            window.location.href = '/'
            break
        case 404:
            //toast.error(localization.ERROR_500)
            break
        case 403:
            toast.error(error.message)
            break
        case 500:
            toast.error(localization.error_500)
            break

        default:
            break
    }
    // if (error.response.status !== 403) toast.error(error.message);
}

export function generateQueryClient() {
    return new QueryClient({
        defaultOptions: {
            queries: {
                onError: QueryErrorHandler,
                staleTime: 0,
                cacheTime: 90000, // default cacheTime is 5 minutes; doesn't make sense for staleTime to exceed cacheTime
                refetchOnMount: false,
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
                retry: false,
            },
            mutations: {
                onError: QueryErrorHandler,
            },
        },
    })
}

export const queryClient = generateQueryClient()
